import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'banner-thank-you',
  styleUrl: 'banner-thank-you.css',
  shadow: true,
})
export class BannerThankYou {
  @Prop() mileage: number;
  @Prop() yearId: number;
  @Prop() make: string;
  @Prop() model: string;
  @Prop() trim: string;
  @Prop() vin: string;
  @Prop() showDesktop: boolean = false;

  render() {
    const bannerClass = {
      'banner-thank-you-block': true,
      'py-6': !this.showDesktop,
      'py-auto': this.showDesktop,
    };
    const bannerThankYouClass = {
      'banner-thank-you': true,
      'pb-6': !this.showDesktop,
    };
    const titleWidth = {
      'banner-thank-title-width': true,
      'max-w-[90vw]': !this.showDesktop,
      'max-w-[500px]': this.showDesktop,
    };
    const tooltipWidth = {
      'banner-thank-tooltip-width': true,
      'max-w-[85vw]': !this.showDesktop,
      'max-w-[30vw]': this.showDesktop,
    };
    const carName = `${this.yearId} ${this.make} ${this.model} ${this.trim}`;
    return (
      <div class={bannerClass}>
        <h3 class={bannerThankYouClass}>Thank You!</h3>
        <div class="flex">
          <div class="tooltip w-full">
            <div class={titleWidth}>{carName}</div>
            <div class={tooltipWidth}>
              <div>{carName}</div>
            </div>
          </div>
        </div>
        <div>Mileage: {this.mileage.toLocaleString()}</div>
        {this.vin && <div class="text-sm leading-4 mt-4">VIN: {this.vin}</div>}
      </div>
    );
  }
}
